import {getByName, type IpAddress} from '../utils/network.ts';
import {type Comparator, compareArrays} from '../utils/collections.ts';

export type Address = Readonly<{
    type: 4 | 6,
    host: string,
    port: number,
    address: IpAddress
}>;
export function addressAsString(address: Pick<Address, 'host' | 'port' | 'type'>): string {
    // todo: do better for ipv6
    return `${address.host}:${address.port}`;
}
export async function toIpAddress(address: Address): Promise<IpAddress> {
    return await getByName(scopedHost(address));
}

export async function fromHostname(hostname: string, port: number): Promise<Address> {
    return new AddressImpl(hostname, await getByName(hostname), port);
}
export function fromIpAddress(address: IpAddress, port: number): Address {

    return new AddressImpl(undefined, address, port);
}

class AddressImpl {
    readonly type: 4 | 6;
    readonly host: string;
    readonly port: number;
    readonly address: IpAddress;

    constructor(hostname: string | undefined, ipAddress: IpAddress, port : number) {
        const type = ipAddress.family;
        if (type !== 4 && type !== 6) {
            throw new Error('unexpected address type');
        }
        this.type= type;
        this.host = hostname ?? ipAddress.address;
        this.port = port;
        this.address = ipAddress;
    }
}

function scopedHost(address: Address): string {
    if (address.type === 6) {
        return `[${address.host}]`;
    }
    return address.host;
}

export const compareAddress: Comparator<Address> = (a1: Address, a2: Address) => {
    const addressBytes1 = a1.address.addressBytes;
    const addressBytes2 = a2.address.addressBytes;
    const result = compareArrays(addressBytes1, 0, addressBytes1.length, addressBytes2, 0, addressBytes2.length, (b1, b2) => {
        return b1 === b2 ? 0 : (b1 > b2 ? 1 : -1);
    });
    if (result !== 0) {
        return result;
    }

    return a1.port === a2.port ? 0 : (a1.port > a2.port ? 1 : -1);
}
